import { Stack, Box, Text, Spinner, Button, ButtonGroup } from '@chakra-ui/react'
// import RadioGroup from '../components/common/RadioGroup'
import { InfoSearchBar } from '../../components/common/InfoSearchBar'
import { PlayerResults } from '../../components/SearchInfo/PlayerResults'
import useGetPlayers, { PlayerData } from 'src/hooks/SearchInfo/useGetPlayers'
import ErrorPage from '../error-page'
import { colors } from 'src/common/colors'
import styled from 'styled-components'
import { useEffect, useState } from 'react'
import useInput from 'src/hooks/useInput'

const levelButtons = ['브론즈', '실버', '골드']

export default function SearchInfo() {
  const [search, handleSearch, setSearch] = useInput('')
  const [selectedButton, setSelectedButton] = useState('')
  const { getPlayers, setPlayerResults, filteredPlayerResults, setFilteredPlayerResults, playerError } = useGetPlayers()

  useEffect(() => {
    const fetchData = async () => {
      const players = await getPlayers(search)
      setPlayerResults(players)
      filterResults(players)
    }
    fetchData()
  }, [search, selectedButton])
  
  const filterResults = (players: PlayerData[]) => {    
    const newFilteredResults = players.filter((result) =>
      selectedButton ? result.childrenLevel.includes(selectedButton) : true
    )
    setFilteredPlayerResults(newFilteredResults)
  }
  
  const buttonFilter = (level: string) => {
    setSelectedButton(prevLevel => prevLevel === level ? '' : level)
  }
  return (
    <Container>
      <Stack width='100%'>
        <Box height='348px'>
          <Text marginBottom='20px' fontSize='22px' color={colors.darkBlue} fontFamily='KFAGothicBold'>선수 조회</Text>
          {/* <Box>
              <RadioGroup radioOptions={levelButtons} name='programLevel' />
            </Box> */}
          <ButtonGroup marginBottom='14px'>
            {levelButtons.map((level) => (
              <Button
                key={level}
                value={level}
                className={`button ${selectedButton === level ? 'selected' : ''}`}
                onClick={() => buttonFilter(level)}
              >
                {level}
              </Button>
            ))}
          </ButtonGroup>
          <InfoSearchBar placeholder='검색하고 싶은 선수를 입력해 주세요.' value={search} onChange={(e) => setSearch(e.target.value)} marginBottom='84px' />
        </Box>
        {(filteredPlayerResults.length > 0 && (search || selectedButton)) ?
          <PlayerResults results={filteredPlayerResults} />
          :
          <Box>
            <Box className='results-header'>
              <Text fontFamily='KFAGothic' fontWeight='400' fontSize='18px' color={colors.darkBlue} marginBottom='18px'>검색 결과</Text>
            </Box>
            {((search || selectedButton) && filteredPlayerResults.length === 0) ?
              <Text fontSize='13px' color={colors.darkBlue} opacity='0.63'>입력하신 선수는 존재하지 않습니다.</Text>
              :
              (!search || !selectedButton) ?
                <Text fontSize='13px' color={colors.darkBlue} opacity='0.63'>검색 후 결과를 확인해 보세요!</Text>
                :
                playerError ?
                  <Box>
                    <ErrorPage />
                  </Box>
                  :
                  <Box>
                    <Spinner />
                  </Box>
            }
          </Box>
        }
      </Stack>
    </Container>
  )
}

const Container = styled.div`
  width: calc(100vw - 506px);
  min-width: 850px;
  margin-right: 92px;
  margin-bottom: 50px;

  .button {
    display: flex;
    flex-direction: column; 
    align-items: center; 
    text-align: center;
    color: ${colors.darkBlue};
    opacity: 0.6;
    padding: 10px 25px;
    font-size: 14px;
    border: 1px solid rgba(19, 28, 77, 0.21);
    background-color: #FFF;
    cursor: pointer;
    width: 74.861px;
    height: 34.878px;
    flex-shrink: 0;
    font-family: KFAGothic;
    font-weight: 400;
    border-radius: 0;

    &:hover {
      color: ${colors.darkBlue};
      background-color: #FFF;
      opacity: 1;
      border: 1px solid rgba(19, 28, 77, 1);
    }
    
    &:active {
      color: ${colors.darkBlue};
      opacity: 1;
      border: 1px solid rgba(19, 28, 77, 1);
    }
  }

  .button.selected {
    color: ${colors.darkBlue};
    opacity: 1;
    border: 0.85px solid rgba(19, 28, 77, 1);
  }
`